'use client';

import { getFlagEmoji } from 'modules/geo/utils';
import { useRouter } from 'next/router';
import React from 'react';
import Link from './Link';
// import { useToggle } from 'react-use';

interface LanguageSwitcherProps {
  // TODO
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps & React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => {
  const router = useRouter();
  // const [open, toggleExtended] = useToggle(false);

  return (
    <nav className={className} {...props}>
      {/* <button onClick={toggleExtended}>
        {router?.locale?.toUpperCase()}
        <FiChevronDown color="#999999" />
      </button> */}

      <ul className="flex items-center gap-2">
        {router.locales
          ?.filter((locale) => locale !== router.locale)
          ?.map((locale) => (
            <li key={locale} className="list-none">
              {router.asPath.includes('#') ? (
                <>
                  {/* A bug in nextjs prevents urls with # from refreshing the page */}
                  <a href={`/${locale}${router.asPath}`}>{locale.toUpperCase()}</a>
                </>
              ) : (
                <Link href={router.asPath} locale={locale} passHref={true}>
                  {getFlagEmoji(locale)}
                </Link>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );
};

export default LanguageSwitcher;
